type tPaginationAnswer = {
    total: number,
    current: number,
    last: number,
    next: string,
    html: string
}

export class NewList {
    wrapper: Element | null
    items: Element | null
    pagination: Element | null
    btnMore: Element | null
    currentPage: number

    constructor() {
        this.currentPage = 1;
        this.wrapper = document.querySelector('.news-section')
        if (!this.wrapper) {
            throw new Error("Список новостей не найден на странице")
        }

        this.items = this.wrapper.querySelector('.news-section__container')
        if (!this.items) {
            throw new Error("Нарушена структура страницы, нет контейнера для списка новостей")
        }

        this.pagination = this.wrapper.querySelector('.news-section__more')
        if (this.pagination) {
            this.btnMore = this.pagination.querySelector('.button')
            if (this.btnMore) {
                this.btnMore.addEventListener('click', async () => {
                    await this.fetchMore()
                })
            }
        } else {
            this.btnMore = null
        }
    }

    private async fetchMore() {
        const response = await fetch(`/news/all/page/${this.currentPage + 1}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                'X-Requested-With': 'XMLHttpRequest'
            },
        });
        if (response.ok) {
            const data = await response.json() as tPaginationAnswer
            this.currentPage = data.current
            if (this.currentPage >= data.last) {
                this.btnMore?.remove()
            }
            if (this.items) {
                this.items.innerHTML += data.html
            }
        } else {
            this.btnMore?.remove()
        }
    }
}